import axios from "axios";
import { useState } from "react";

export const useVerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  async function handleVerify() {
    try {
      setLoading(true);
      const pending = JSON.parse(
        sessionStorage.getItem("pendingLogin") || "null"
      );
      if (!pending || !pending.email) {
        setError(true);
        setLoading(false);
        return;
      }

      const payload = {
        email: pending.email,
        otp,
      };

      const response = await axios.post("/api/users/verify-otp", payload);
      setLoading(false);
      if (response.data && response.data.success) {
        // Persist according to rememberMe present on pending
        localStorage.setItem("isRememberMe", pending.isRememberMe ?? false);
        const storage = pending.isRememberMe ? localStorage : sessionStorage;
        storage.setItem("currentUser", JSON.stringify(response.data.user));
        sessionStorage.removeItem("pendingLogin");
        window.location.href = "/";
      } else {
        setError(true);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(true);
    }
  }

  return { otp, setOtp, loading, error, handleVerify };
};
